export default [
  {
    path: '/educationService/index',
    name: 'educationService_index',
    component: () => import('@/views/educationService/index'),
    meta: { title: "人才教育服务子平台", requireLogin: false }
  },
  {
    path: '/educationService/components/recruitment',
    name: 'educationService_recruitment',
    component: () => import('@/views/educationService/components/recruitment'),
    meta: { title: "科研助理招聘", requireLogin: false }
  },
  {
    path: '/educationService/components/recruitmentDetail',
    name: 'educationService_recruitmentDetail',
    component: () => import('@/views/educationService/components/recruitmentDetail'),
    meta: { title: "科研助理招聘详情", requireLogin: false }
  },
  {
    path: '/educationService/components/thinktank',
    name: 'educationService_thinktank',
    component: () => import('@/views/educationService/components/thinktank'),
    meta: { title: "产业智库", requireLogin: false }
  },
  {
    path: '/educationService/components/thinktankDetail',
    name: 'educationService_thinktankDetail',
    component: () => import('@/views/educationService/components/thinktankDetail'),
    meta: { title: "产业智库详情", requireLogin: false }
  },
  {
    path: '/educationService/components/findpeople',
    name: 'educationService_findpeople',
    component: () => import('@/views/educationService/components/findpeople'),
    meta: { title: "找人才", requireLogin: false }
  },
  {
    path: '/educationService/components/findpeopleDetail',
    name: 'educationService_findpeopleDetail',
    component: () => import('@/views/educationService/components/findpeopleDetail'),
    meta: { title: "找人才详情", requireLogin: false }
  },
  {
    path: '/educationService/components/entrepreneurshipMentor',
    name: 'educationService_entrepreneurshipMentor',
    component: () => import('@/views/educationService/components/entrepreneurshipMentor'),
    meta: { title: "创业导师", requireLogin: false }
  },
  {
    path: '/educationService/components/entrepreneurshipMentorDetail',
    name: 'educationService_entrepreneurshipMentorDetail',
    component: () => import('@/views/educationService/components/entrepreneurshipMentorDetail'),
    meta: { title: "创业导师详情", requireLogin: false }
  },
  {
    path: '/educationService/components/talentpolicy',
    name: 'educationService_talentpolicy',
    component: () => import('@/views/educationService/components/talentpolicy'),
    meta: { title: "人才政策", requireLogin: false }
  },
  {
    path: '/educationService/components/talentpolicyDetail',
    name: 'educationService_talentpolicyDetail',
    component: () => import('@/views/educationService/components/talentpolicyDetail'),
    meta: { title: "人才政策详情", requireLogin: false }
  },
]
